export default "__VITE_ASSET__CBI2G0_K__"